import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { useSelector } from "react-redux";

import LinkHandler from "../atoms/LinkHandler";
import Image from "../atoms/Image";
import Config from "../../constants/Config";
import LogoPlaceholder from "../../../assets/images/logo-placeholder.png";
import ClubExecMenuModal from "./ClubExecMenuModal";
import Icon from "../atoms/Icon";

interface PropsType extends RouteComponentProps {
    match: any;
    activeClub: number | string;
    clubs: any[];
    setActiveClub: Function;
}

const NavManageClubs = (props: PropsType) => {
    const [clubExecMenuModalActive, setClubExecMenuModalActive] =
        React.useState(false);
    const {
        club_resources_link,
        create_event_form_link,
        create_sponsorship_form_link,
        create_grant_form_link,
        create_governance_form_link,
    } = useSelector((state: any): any => state.options);

    const manageTabs = [
        {
            name: "Events",
            route: `${Config.routes.manageClubs}/${props.activeClub}/events`,
        },
        {
            name: "Grants",
            route: `${Config.routes.manageClubs}/${props.activeClub}/grants`,
        },
        {
            name: "Resources",
            route: club_resources_link ? club_resources_link.url : "",
            target: club_resources_link ? club_resources_link.target : "",
        },
    ];

    let selectedClub = props.clubs[0];

    if (props.activeClub) {
        selectedClub = props.clubs.filter(
            club =>
                club.ID ===
                (typeof props.activeClub === "string"
                    ? parseInt(props.activeClub)
                    : props.activeClub)
        )[0];
    }

    return (
        <div className="nav-manage-clubs">
            <div className="nav-manage-clubs__tab">
                <div className="nav-manage-clubs__logo">
                    {selectedClub ? (
                        <Image
                            key={selectedClub.ID}
                            src={
                                selectedClub.acf.logo &&
                                selectedClub.acf.logo.url
                                    ? selectedClub.acf.logo.url
                                    : LogoPlaceholder
                            }
                            alt="Club Logo"
                            aspectRatio="1:1"
                        />
                    ) : null}
                </div>
                {props.clubs.length > 1 ? (
                    <React.Fragment>
                        <select
                            className="nav-manage-clubs__select"
                            value={props.activeClub ?? ""}
                            onChange={e => props.setActiveClub(e.target.value)}
                        >
                            {props.clubs.map((club, key) => {
                                return (
                                    <option key={club.ID} value={club.ID}>
                                        {club.post_title}
                                    </option>
                                );
                            })}
                        </select>
                        <div className="nav-manage-clubs__select__select-indicator"></div>
                    </React.Fragment>
                ) : (
                    <div className="nav-manage-clubs__club-text">
                        {selectedClub ? selectedClub.post_title : ""}
                    </div>
                )}
            </div>
            {manageTabs.map(tab => {
                return (
                    <div key={tab.name} className="nav-manage-clubs__tab">
                        <LinkHandler
                            className="nav-manage-clubs__tab__link"
                            activeClassName="nav-manage-clubs__tab__link--active"
                            to={tab.route}
                            target={tab.target}
                        >
                            {tab.name}
                        </LinkHandler>
                    </div>
                );
            })}
            <div className="nav-manage-clubs__tab nav-manage-clubs__tab--slim">
                <button
                    className="nav-manage-clubs__tab__button nav-manage-clubs__tab__link"
                    onClick={() => setClubExecMenuModalActive(true)}
                >
                    <span className="nav-manage-clubs__tab__button__text-wrapper">
                        More
                    </span>
                    <Icon
                        name="vertical-ellipsis"
                        className="nav-manage-clubs__tab__button__icon"
                        width="12px"
                        height="12px"
                    />
                </button>
            </div>
            <ClubExecMenuModal
                active={clubExecMenuModalActive}
                onClose={() => setClubExecMenuModalActive(false)}
                onLinkSelection={() => setClubExecMenuModalActive(false)}
                clubs={props.clubs}
                activeClubId={
                    typeof props.activeClub === "string"
                        ? parseInt(props.activeClub)
                        : props.activeClub
                }
                setActiveClub={clubId => props.setActiveClub(clubId)}
                submitEventUrl={create_event_form_link?.url}
                submitGrantUrl={create_grant_form_link?.url}
                resourcesUrl={club_resources_link?.url}
                submitGovernanceUrl={create_governance_form_link?.url}
                submitSponsorshipUrl={create_sponsorship_form_link?.url}
            ></ClubExecMenuModal>
        </div>
    );
};

NavManageClubs.preload = ({
    location,
    passed: { store },
}: any): Promise<any> => {
    return Promise.all([]);
};

export default withRouter(NavManageClubs);
